module.exports = __webpack_public_path__ + "static/media/videoTitle.4664305b.mp3";